export function isPostBodyBackgroundClick(event) {
  if (event.defaultPrevented || window.getSelection()?.toString()) return false;
  const card = event.currentTarget;
  const control = event.target.closest('a, button, input, textarea, select, [role="button"], [contenteditable="true"], img, video, audio, .dr-post-header, .status__action-bar, .status__content, .media-gallery__item, .video-player, .audio-player, .status-card');
  if (control && control !== card && card.contains(control)) return false;
  const header = card.querySelector(':scope > .dr-post-header');
  const footer = card.querySelector(':scope > .status__action-bar');
  return event.clientY >= (header?.getBoundingClientRect().bottom ?? card.getBoundingClientRect().top)
    && event.clientY <= (footer?.getBoundingClientRect().top ?? card.getBoundingClientRect().bottom);
}
